module.exports = __webpack_public_path__ + "b8cad4bfe819581267f681712838e75e.jpg";